module.exports = __webpack_public_path__ + "img/SWP_Axe_1H_06 (1).4ddc3ce2.png";